import { useMutate } from 'restful-react'
import { ResetPasswordBody } from './interfaces'

const useResetPassword = () => {
    return useMutate<any, any, any, ResetPasswordBody>('POST', '/user/resetlgpdpassword')
}

export default useResetPassword
